module.exports = __webpack_public_path__ + "static/img/page4.d09ecd71.jpg";